module.exports = __webpack_public_path__ + "../public/img/calculator.96cc7af6.png";